export default {
      id: "icon-chevron-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.10719bc6.svg#icon-chevron",
      toString: function () {
        return this.url;
      }
    }